













import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class BulkBookSales extends Vue {
  @Prop() public checkedDeliveryItems:Array<Common.SalesDeliveryItem>; 
  @Prop() public parentMainList:Components.ListView;
  @Prop() public salesDeliveryItems:Components.GrdVoucherItem;
  @Prop() public parentSalesDelivery:Common.SalesDelivery;
  @Prop() public parent:any;
  @Prop() public isItemFlag:boolean;

  public bsWorkflowIdAlone:number = 0;
  public bsWorkflowIdCarryOver:number = 0;
  public bsHasAlone:boolean = true;
  public bsHasCarryOver:boolean = true;
  public bsBankAccount: Common.BankAccount = null;

  
  // 一括請求処理ダイアログの表示
  public mounted(){
    // 出荷から実行した場合に必要な情報の設定
    if(this.parentSalesDelivery)
    {
      this.checkedDeliveryItems.forEach(item => {
        item.delivery = this.parentSalesDelivery;
        item.segment = this.parentSalesDelivery.segment;
      });
    }

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.invoiceType == Common.InvoiceTypes.SeparateInvoice).length > 0){
      this.$api.modal.show('', '個別請求が設定されている得意先は、一括請求処理できません。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.SalesDeliveryAcceptanceWaiting).length > 0){
      this.$api.modal.show('', '請求処理待ちの明細のみを選択して下さい。', true, null);
      return;
    }

     if(this.checkedDeliveryItems.filter(item => this.checkedDeliveryItems[0].delivery.currencyCode != item.delivery.currencyCode).length > 0){
      this.$api.modal.show('', '取引通貨の異なる出荷明細は、一括請求処理できません。', true, null);
      return;
    }
    
    this.bsWorkflowIdAlone = this.$api.perms.getDefaultWorkflowId('workflow_aloneInvoice');
    this.bsWorkflowIdCarryOver = this.$api.perms.getDefaultWorkflowId('workflow_carryOverInvoice' );

    this.bsHasAlone = this.checkedDeliveryItems.filter(item =>item.delivery.counterpart.invoiceType != Common.InvoiceTypes.ConsolidateInvoiceCarryOver).length > 0;
    this.bsHasCarryOver = this.checkedDeliveryItems.filter(item =>item.delivery.counterpart.invoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver).length > 0;    
    // this.getBankAccount(this.checkedDeliveryItems[0].delivery.currencyCode);

    // 得意先に設定されている請求口座を初期値として設定（複数ある場合ブランク）
    var customerList = new Array<Common.Counterpart>();
    this.checkedDeliveryItems.forEach(obj => customerList.push(obj.delivery.counterpart));
    this.getBankAccount(customerList);


    // ダイアログの表示
    (this.$refs.bulkBookSalesDialog as Components.ListDialog).showDialog();

  }

  // public async getBankAccount(currencyCode:string){
  //   const query = new Common.GetBankAccount();
  //   query.currencyCode = currencyCode;
  //   this.$api.execute(query).then(res => {
  //     this.bsBankAccount = res as Common.BankAccount;
  //   });
  // }
  public async getBankAccount(customerList:Array<Common.Counterpart>){
    const query = new Common.GetCusotmerBankAccountQuery();
    query.customerList = customerList;
    this.$api.execute(query).then(res => {
      if(res != null)this.bsBankAccount = res as Common.BankAccount;//初期値を設定するようになったのでブランクで上書きをしないように変更
    });
  }

  // 一括請求処理の実行
  public async submitBulkBookSales() {
     // クエリの設定
    var query = new Common.BookSalesQuery();
    query.deliveryItems = this.checkedDeliveryItems;
    query.separateInvoiceFlag = false;
    query.bookDate = new Date().getCalendarDate();
    query.dueDate = null;
    query.bulkFlag = true;
    query.exchangeRate = 1;
    query.bankAccount = this.bsBankAccount;
    query.workflowIdAlone = this.bsWorkflowIdAlone;
    query.workflowIdCarryOver = this.bsWorkflowIdCarryOver;
    
    (this.$refs.bulkBookSalesDialog as Components.ListDialog).closeDialog();
    // 請求処理の実行
    return this.$api.execute(query,true).then(res =>{ 
      // 画面を更新
      if(this.isItemFlag){
        this.parentMainList.reload().then(()=>{if(this.salesDeliveryItems) this.salesDeliveryItems.onVoucherNoChanged();});
      }else{
        this.$api.find('Delivery', [((this.parentMainList as Components.ListView).selected as Common.SalesDelivery).deliveryNo]).then(res2 => 
          this.parent.onWorkflow(this.parentMainList.currentId,res2));
      }

      var invoices = res as Common.Invoice[];
      var links = invoices.map(invoice=> new Common.ModalLink(invoice.invoiceNo,this.getInvoiceLink(invoice)));
      if(invoices.length == 1){
        this.$api.modal.show('処理結果','以下の請求書が作成・更新されました。',false,()=>{
          var url = this.getInvoiceLink(invoices[0]);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果','以下の請求書が作成・更新されました。',true,null,links,'閉じる');
      }
      return true;        
      }).catch(()=>false);        
  }

  // 請求のリンク先を設定
  private getInvoiceLink(invoice:Common.Invoice)
  {
    if(invoice.invoiceType == Common.InvoiceTypes.ConsolidateInvoiceCarryOver)
      return String.format('/sales/CarryoverInvoice?invoiceNo={0}',invoice.invoiceNo);
    else
      return String.format('/sales/AloneInvoice?invoiceNo={0}',invoice.invoiceNo);
  }
}

